import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const privacyPolicyApi = {
  getPrivacyPolicy: async () => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.PRIVACY_POLICY}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching Privacy Policy:', error);
      throw error;
    }
  },

  createPrivacyPolicy: async (data) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.PRIVACY_POLICY}`, data);
      return response.data;
    } catch (error) {
      console.error('Error creating Privacy Policy:', error);
      throw error;
    }
  },

  updatePrivacyPolicy: async (data) => {
    try {
      const response = await apiClient.put(`${API_ENDPOINTS.PRIVACY_POLICY}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating Privacy Policy:', error);
      throw error;
    }
  },
};

export default privacyPolicyApi;